import {computed, ref, Ref} from '@vue/composition-api';
import FlightIcon from '../svg/airplane2.vue';
import StayIcon from '../svg/stay.vue';
import MarkerIcon from '../svg/marker2.vue';
import DiningIcon from '../svg/dining.vue';

import {VueConstructor} from 'vue/types/umd';
import {IDateDescription, UserActivityCategoryEnum} from '@mobi-components/global-solution';
import {RouterAliases} from '@/router/routerAliases';
import {useRouter} from '@/router';
import {Dictionary} from 'vue-router/types/router';
import {useParams} from '@/router/router';

export enum HeaderIconType {
  FLIGHT,
  STAY,
  EXPLORE,
  DINE,
  // ONBOARD,
}

export interface HeaderIcon {
  id: string;
  active: boolean;
  completed: boolean;
  name: string;
  icon: VueConstructor;
  type: HeaderIconType;
  pathName: RouterAliases;
}

export type RoutingCategory =
  | UserActivityCategoryEnum.ACCOMMODATION
  | UserActivityCategoryEnum.EXPERIENCE
  | UserActivityCategoryEnum.DINING;

export interface OpenCategoryEvent {
  cat: RoutingCategory;
  date?: IDateDescription;
}

const categoryMapping = {
  [UserActivityCategoryEnum.ACCOMMODATION]: RouterAliases.ACCOMMODATION_EXPLORE_VIEW,
  [UserActivityCategoryEnum.EXPERIENCE]: RouterAliases.EXPERIENCE_EXPLORE_VIEW,
  [UserActivityCategoryEnum.DINING]: RouterAliases.DINNING_EXPLORE_VIEW,
  [UserActivityCategoryEnum.FLIGHT]: RouterAliases.FLIGHT_EXPLORE_VIEW,
};

export function useDetailsHeader(
  // isHotelCompleted?: Ref<boolean>,
  // isDinningCompleted?: Ref<boolean>,
  // isExperienceCompleted?: Ref<boolean>,
  isFlightsHidden?: Ref<boolean>,
) {
  const icons = ref<Record<HeaderIconType, HeaderIcon>>({
    // [HeaderIconType.FLIGHT]: {
    //   id: '1',
    //   get active() {
    //     const router = useRouter();
    //     return router.currentRoute.name === RouterAliases.FLIGHT_EXPLORE_VIEW;
    //   },
    //   get completed() {
    //     return process.env.VUE_APP_THEME === 'AMEX' ? false : true;
    //   },
    //   name: 'Flights',
    //   icon: FlightIcon,
    //   type: HeaderIconType.FLIGHT,
    //   pathName: RouterAliases.FLIGHT_EXPLORE_VIEW,
    //   category: UserActivityCategoryEnum.FLIGHT,
    // },
    [HeaderIconType.STAY]: {
      id: '2',
      get active() {
        const router = useRouter();
        return router.currentRoute.name === RouterAliases.ACCOMMODATION_EXPLORE_VIEW;
      },
      get completed() {
        return false; //process.env.VUE_APP_THEME === 'AMEX' ? false : isHotelCompleted?.value;
      },
      name: 'Stays',
      icon: StayIcon,
      type: HeaderIconType.STAY,
      pathName: RouterAliases.ACCOMMODATION_EXPLORE_VIEW,
      category: UserActivityCategoryEnum.ACCOMMODATION,
    },
    [HeaderIconType.EXPLORE]: {
      id: '3',
      get active() {
        const router = useRouter();
        return router.currentRoute.name === RouterAliases.EXPERIENCE_EXPLORE_VIEW;
      },
      get completed() {
        return false; //process.env.VUE_APP_THEME === 'AMEX' ? false : isExperienceCompleted?.value;
      },
      name: 'EXPERIENCES',
      icon: MarkerIcon,
      type: HeaderIconType.EXPLORE,
      pathName: RouterAliases.EXPERIENCE_EXPLORE_VIEW,
      category: UserActivityCategoryEnum.EXPERIENCE,
    },
    [HeaderIconType.DINE]: {
      id: '4',
      get active() {
        const router = useRouter();
        return router.currentRoute.name === RouterAliases.DINNING_EXPLORE_VIEW;
      },
      get completed() {
        return false; //process.env.VUE_APP_THEME === 'AMEX' ? false : isDinningCompleted?.value;
      },
      name: 'DINING',
      icon: DiningIcon,
      type: HeaderIconType.DINE,
      pathName: RouterAliases.DINNING_EXPLORE_VIEW,
      category: UserActivityCategoryEnum.DINING,
    },
  });

  const headerIcons = computed(() => {
    return Object.keys(icons.value)
      .filter((key) => {
        if (isFlightsHidden && isFlightsHidden.value && key === HeaderIconType.FLIGHT.toString()) {
          return false;
        }
        return true;
      })
      .map((x) => icons.value[(x as unknown) as HeaderIconType]);
  });

  const onSelectDetailsView = (item: HeaderIcon) => {
    onOpenRoute(item.pathName);
  };

  const isFlightsActive = computed(() => {
    return icons.value[HeaderIconType.FLIGHT].active;
  });
  const isHotelsActive = computed(() => {
    return icons.value[HeaderIconType.STAY].active;
  });
  const isExperiencesActive = computed(() => {
    return icons.value[HeaderIconType.EXPLORE].active;
  });
  const isDineActive = computed(() => {
    return icons.value[HeaderIconType.DINE].active;
  });

  const onOpenRoute = (routeName: RouterAliases, query?: Dictionary<string | (string | null)[]>) => {
    const router = useRouter();
    const params = useParams();
    router.push({name: routeName, query, params: {...params.value, poiId: ''}});
  };

  const onOpenCategory = (data: OpenCategoryEvent) => {
    onOpenRoute(categoryMapping[data.cat] || RouterAliases.SUMMARY_VIEW, {
      date: data?.date?.date?.valueOf().toString() || '',
    });
  };

  const replaceCategory = (data: OpenCategoryEvent) => {
    const router = useRouter();
    const params = useParams();
    router.replace({
      name: categoryMapping[data.cat] || RouterAliases.SUMMARY_VIEW,
      query: {date: data?.date?.date?.valueOf().toString() || ''},
      params: params.value,
    });
  };

  const onHotelsOpen = () => {
    return onOpenRoute(RouterAliases.ACCOMMODATION_EXPLORE_VIEW);
  };

  const onExperiencesOpen = () => {
    return onOpenRoute(RouterAliases.EXPERIENCE_EXPLORE_VIEW);
  };

  const onDiningOpen = () => {
    return onOpenRoute(RouterAliases.DINNING_EXPLORE_VIEW);
  };

  const onFlightsOpen = () => {
    onOpenRoute(RouterAliases.FLIGHT_EXPLORE_VIEW);
  };

  return {
    headerIcons,
    onSelectDetailsView,
    isFlightsActive,
    isHotelsActive,
    isExperiencesActive,
    isDineActive,
    onOpenRoute,
    onOpenCategory,
    onHotelsOpen,
    onExperiencesOpen,
    onDiningOpen,
    onFlightsOpen,
    replaceCategory,
  };
}
